import React from 'react';
import PropTypes from 'prop-types';
import './index.less';

const ExplainHeader = ({children, className}) => {
    const cls = className ? `cas-fe-explain-header ${className}` : 'cas-fe-explain-header';
    return (
        <header className={cls}>
            {children}
        </header>
    );
};

ExplainHeader.defaultProps = {
    children: null,
    className: '',
};

ExplainHeader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default ExplainHeader;

